<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="toc">
<p class="C333" id="page_v">
<strong>CONTENTS</strong>
</p>
<p class="C336">
<a href="#/xhtml/05_General_editors__preface#page_vii">General editors' preface</a>
</p>
<p class="C336">
<a href="#/xhtml/06_Acknowledgements#page_ix">Acknowledgements</a>
</p>
<p class="C336">
<a href="#/xhtml/07_Chronology#page_x">Chronology</a>
</p>
<p class="C336">
<a href="#/xhtml/08_Cue_titles#page_xiii">Cue-titles</a>
</p>
<p class="C336">
<a href="#/xhtml/09_Introduction#page_xv">Introduction</a>
</p>
<p class="C337"><em><a href="#/xhtml/10_Body#page_1">SEA AND SARDINIA</a></em></p>
<p class="C337A"><span href="#/xhtml/14_I__As_far_as_Palermo#page_7" title="Link target outside of Sample">I. As far as Palermo</span></p>
<p class="C337A"><span href="#/xhtml/15_II__The_Sea#page_25" title="Link target outside of Sample">II. The Sea</span></p>
<p class="C337A"><span href="#/xhtml/16_III__Cagliari#page_55" title="Link target outside of Sample">III. Cagliari</span></p>
<p class="C337A"><span href="#/xhtml/17_IV__Mandas#page_70" title="Link target outside of Sample">IV. Mandas</span></p>
<p class="C337A"><span href="#/xhtml/18_V__To_Sorgono#page_84" title="Link target outside of Sample">V. To Sorgono</span></p>
<p class="C337A"><span href="#/xhtml/19_VI__To_Nuoro#page_115" title="Link target outside of Sample">VI. To Nuoro</span></p>
<p class="C337A"><span href="#/xhtml/20_VII__To_Terranova_and_the_Steame#page_141" title="Link target outside of Sample">VII. To Terranova and the Steamer</span></p>
<p class="C337A"><span href="#/xhtml/21_VIII__Back#page_169" title="Link target outside of Sample">VIII. Back</span></p>
<p class="C336">
<span href="#/xhtml/22_Appendix__Maps_of_Sardinia__Sici#page_193" title="Link target outside of Sample">Appendix: Maps of Sardinia, Sicily and southern Italy <em>(c</em>. 1921)</span>
</p>
<p class="C336">
<span href="#/xhtml/24_Explanatory_notes#page_199" title="Link target outside of Sample">Explanatory notes</span>
</p>
<p class="C336">
<span href="#/xhtml/26_Glossary_of_selected_Italian_ter#page_218" title="Link target outside of Sample">Glossary of selected Italian terms</span>
</p>
<p class="C336">
<span href="#/xhtml/27_A_note_on_pounds__shillings_and#page_239" title="Link target outside of Sample">A note on pounds, shillings and pence</span>
</p>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_CONTENTS.vue?82eaa858